<template>
<div>
    <div class="p-2 d-flex" :style="skin.live_lobby.bar">
        <div :style="screen_width>skin.break_point?'width: 20%;':'width:30%;'">
            <span>{{translate("next")}}</span>
        </div>
        <div class="d-flex" :style="screen_width>skin.break_point?'width: 80%;':'width:70%;overflow-x:auto;'">
            <div style="width: 90%;"></div>
            <div class="mx-3" v-for="(deporte,index) in deportes" v-bind:key="index" style="cursor:pointer"
            :class="deporte.id == 1 ? 'nav_active': ''"
            @click="select_sport(deporte.id)"
            >
                <div :title="deporte.name" class="icon_futbol" style="width:20px;height:20px" v-if="deporte.id==1"></div>
                <div :title="deporte.name" class="icon_hockey" style="width:20px;height:20px" v-else-if="deporte.id==2"></div>
                <div :title="deporte.name" class="icon_basket" style="width:20px;height:20px" v-else-if="deporte.id==3"></div>
                <div :title="deporte.name" class="icon_tenis" style="width:20px;height:20px" v-else-if="deporte.id==4"></div>
                <div :title="deporte.name" class="icon_beisball" style="width:20px;height:20px" v-else-if="deporte.id==11||deporte.id==104"></div>
                <div :title="deporte.name" class="icon_futsal" style="width:20px;height:20px" v-else-if="deporte.id==26 || deporte.id==24"></div>
                <div :title="deporte.name" class="icon_tenis_mesa" style="width:20px;height:20px" v-else-if="deporte.id==41"></div>
                <div :title="deporte.name" class="icon_eGames" style="width:20px;height:20px" v-else-if="deporte.id==73||deporte.id==74||deporte.id==75||deporte.id==76||deporte.id==77||deporte.id==80||deporte.id==82||deporte.id==83||deporte.id==71||deporte.id==158||deporte.id==260||deporte.id==208||deporte.id==185"></div>
                <div :title="deporte.name" class="icon_basket" style="width:20px;height:20px" v-else-if="deporte.id==205"></div>
                <div :title="deporte.name" class="icon_badminton" style="width:20px;height:20px" v-else-if="deporte.id==9"></div>
                <div :title="deporte.name" class="icon_balon_mano" style="width:20px;height:20px" v-else-if="deporte.id==29"></div>
                <div :title="deporte.name" class="icon_rugby" style="width:20px;height:20px" v-else-if="deporte.id==37"></div>
                <div :title="deporte.name" class="icon_snoker" style="width:20px;height:20px" v-else-if="deporte.id==39"></div>
                <div :title="deporte.name" class="icon_dardos" style="width:20px;height:20px" v-else-if="deporte.id==22"></div>
                <div :title="deporte.name" class="icon_volleyball" style="width:20px;height:20px" v-else-if="deporte.id==14"></div>
                <div :title="deporte.name" class="icon_cricket" style="width:20px;height:20px" v-else-if="deporte.id==19"></div>
                <div :title="deporte.name" class="icon_waterpolo" style="width:20px;height:20px" v-else-if="deporte.id==42"></div>
                <div :title="deporte.name" class="icon_golf" style="width:20px;height:20px" v-else-if="deporte.id==27"></div>
                <div :title="deporte.name" class="icon_rugby1" style="width:20px;height:20px" v-else-if="deporte.id==36"></div>
                <div :title="deporte.name" class="icon_volleyball" style="width:20px;height:20px" v-else-if="deporte.id==5"></div> 
                <div :title="deporte.name" class="icon_futAmericano" style="width:20px;height:20px" v-else-if="deporte.id==6"></div> 
                <div :title="deporte.name" class="icon_futbol_australiano" style="width:20px;height:20px" v-else-if="deporte.id==8"></div>
                <div :title="deporte.name" class="icon_boxeo" style="width:20px;height:20px" v-else-if="deporte.id==17"></div>
                <div :title="deporte.name" class="icon_ciclismo" style="width:20px;height:20px" v-else-if="deporte.id==21"></div>
                <div :title="deporte.name" class="icon_race" style="width:20px;height:20px" v-else-if="deporte.id==25 || deporte.id==33 || deporte.id==32 || deporte.id==101"></div>
                <div :title="deporte.name" class="icon_mma" style="width:20px;height:20px" v-else-if="deporte.id==44"></div>
                <div :title="deporte.name" class="icon_hurling" style="width:20px;height:20px" v-else-if="deporte.id==70"></div>
                <div :title="deporte.name" class="icon_squash" style="width:20px;height:20px" v-else-if="deporte.id==88"></div>
                <div :title="deporte.name" class="icon_specials" style="width:20px;height:20px" v-else-if="deporte.id==90"></div>
                <div :title="deporte.name" class="icon_specials" style="width:20px;height:20px" v-else></div>
            </div>
        </div>
    </div>
    <div>
        <div v-if="screen_width>skin.break_point">
            <div v-if="selected_sport==1">
                <div class="px-3">
                    <Futbol
                        :Skin="skin"
                        :translation="translation"
                        :language="language"
                    ></Futbol>
                </div>
            </div>
            <div v-else-if="selected_sport==76">
                <div class="px-3">
                    <Rugby
                        :Skin="skin"
                        :translation="translation"
                        :language="language"
                    ></Rugby>
                </div>
            </div>
            <div v-else>
                <div class="px-3">
                    <Cricket
                        :Skin="skin"
                        :translation="translation"
                        :language="language"
                    ></Cricket>
                </div>
            </div>
        </div>
        <encuentro v-for="game in events"
          v-bind:game="game"
          v-bind:sport="selected_sport"
          v-bind:Skin="skin"
          v-bind:key="game.id"
          v-bind:language="language"
          v-bind:translation="translation"
        />
        <div @click="more_events()" class="text-center p-3">
             <span :style="skin.prematch_lobby_main.more_events" style="cursor:pointer" class="p-2">{{translate("load_more_events")}}</span>
        </div>
    </div>
</div>
</template>

<script>
import encuentro from '../main_events_prematch2/Encuentro.vue';
import Futbol from '../sport_tables/futbol.vue';
import Cricket from '../sport_tables/cricket.vue';
import Rugby from '../sport_tables/rugby.vue';
import Tenis from '../sport_tables/tenis.vue';
import Balonmano from '../sport_tables/balonmano.vue';
export default {
    name:"main_prematch2",
    props:['skin','translation','language','menu_visible'],
    components:{
        encuentro,
        Futbol,
        Cricket,
        Rugby,
        Tenis,
        Balonmano
    },
    data(){
        return{
            selected_sport:1,
            screen_width:0,
            events_limit:11,
        }
    },
    computed:{
        deportes(){
            var list=[];
            var counter = 0;
            let data = this.$store.getters['prematch_2/getSports'];
            Object.keys(data).forEach(sport=>{
                if(counter<10){
                    list.push({
                        name:data[sport].name,
                        id:data[sport].id
                    })
                    counter++;
                }
            });
            return list;
        },
        events(){
            let events = [];
            let ligas = [];
            let count = 0;
            let data = this.$store.getters['prematch_2/getSports'];
            let regions_banned = this.$store.getters['getConfig'].SkinConfig.main.hideRegionsPrematch;
            let words_banned = this.$store.getters['getConfig'].SkinConfig.main.hideWords;
            let ligas_banned = this.$store.getters['getConfig'].SkinConfig.main.hideCompetitionsPrematch;
            Object.keys(data).forEach(sport=>{
                if(data[sport].id == this.selected_sport){
                    Object.keys(data[sport].region).forEach(pais=>{
                    if(data[sport].region[pais]){
                        if(!regions_banned.includes(data[sport].region[pais].alias)){
                            if(data[sport].region[pais].competition){
                                Object.keys(data[sport].region[pais].competition).forEach(liga=>{
                                    data[sport].region[pais].competition[liga].sport = data[sport].id;
                                    data[sport].region[pais].competition[liga].sport_alias = data[sport].alias;
                                    data[sport].region[pais].competition[liga].country = data[sport].region[pais].name;
                                    data[sport].region[pais].competition[liga].country_alias = data[sport].region[pais].alias;
                                    data[sport].region[pais].competition[liga].country_id = data[sport].region[pais].id;
                                    ligas.push(data[sport].region[pais].competition[liga]);
                                });
                            }
                        }
                    }
                });
                }
                
            });
            ligas.sort((a,b) => (a.order > b.order) ? 1 : ((b.order > a.order) ? -1 : 0));
            ligas.forEach(liga=>{
                if((liga ? (liga.game ? true : false) : false)){
                    Object.keys(liga.game).forEach(element=>{
                        if(liga.game[element]){
                            if(liga.game[element] && liga.game[element].info && !liga.game[element].favorite){
                                let banned = false;
                                words_banned.forEach(word => {
                                    if(liga.game[element].team1_name){
                                        if(liga.game[element].team1_name.includes(word)){
                                            banned = true;
                                        }
                                    }
                                    if(liga.game[element].team2_name){
                                        if(liga.game[element].team2_name.includes(word)){
                                            banned = true;
                                        }
                                    }            
                                });
                                ligas_banned.forEach(word => {
                                    if(liga.name){
                                        if(liga.name.includes(word)){
                                            banned = true;
                                        }
                                    }           
                                });
                                if(!banned && liga.game[element].market){
                                    liga.game[element]['sport'] = this.$props.deporte;
                                    if(count<this.events_limit && Object.keys(liga.game[element].market).length>0 && !liga.game[element].is_blocked){
                                        liga.game[element].liga = liga.name;
                                        liga.game[element].liga_id = liga.id;
                                        liga.game[element].sport = liga.sport;
                                        liga.game[element].country = liga.country;
                                        liga.game[element].country_id = liga.country_id;
                                        liga.game[element].country_alias = liga.country_alias;
                                        liga.game[element].sport_alias = liga.sport_alias;
                                        events.push(liga.game[element]);
                                        count++;
                                    }
                                }
                            }  
                        } 
                    });
                }
            });
            events.sort((a,b) => (a.start_ts > b.start_ts) ? 1 : ((b.start_ts > a.start_ts) ? -1 : 0))
            return events; 
        },
        nav_active(){
            return {
                '--nav-active-color':this.$props.skin.prematch_lobby_main.nav_active_color,
                '--nav-active-bar':this.$props.skin.prematch_lobby_main.nav_active_bar
            };
        }
    },
    methods:{
        select_sport(id){
            let items = document.getElementsByClassName("nav-prematch");
            [...items].forEach(item=>{
                item.classList.remove('nav_active');
            });
            if(document.getElementById(id)){
                 document.getElementById(id).classList.add('nav_active');
            }
            this.selected_sport = id;
        },
        sizeControl(){
            this.screen_width=window.innerWidth;
        },
        more_events(){
            this.events_limit *= this.events_limit * 2 > 100 ? 1 : 2;
        },
        translate(text) {
            if (this.$props.translation[text]) {
                return this.$props.translation[text][this.$props.language];
            }
            return text;
        },
    },
    mounted() {
        window.addEventListener('resize', ()=>{this.sizeControl();});
    },
    created(){
        this.sizeControl();
    }
}
</script>

<style scoped>
  .nav_active{
      color:var(--nav-active-color);
      border-bottom: var(--nav-active-bar);
  }
</style>